export default "__VITE_ASSET__0aJKFerh__"